// store/modules/userList.js
import api from '@/utils/api'
import { createListModule } from '@/store/utils/createListModule'

export default createListModule(api.getExposureList, {
  listKey: 'records'
})